export default customElements.define('w-heading-stripe', class HeadingStripe extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            hasChildren: true,

            // Pre-cache tab and right slots as dom cache wont
            // pick up elements inside nested components after initial construction
            cacheDom: ['data-tabs', 'data-right']
        };

        super(config);

        this.onConnectedCallback = () => {
            if (this.#isRightSlotted) {
                this.dom.right.classList.remove('u-display__none');
            }

            if (!this.#isValidTabSlot) {
                return wealthify.error.throwError(this.tagName, `The slot content for "tabs" in the "${this.tagName}" component can only be the "w-tab-panel-menu" component.`);
            }
        };
    }

    // static

    static styleSelector = 'c-heading-stripe';

    static template = `
                <w-section class="c-heading-stripe" data-root>
                    <w-wrapper reduced="true" data-wrapper>
                        <div class="${this.styleSelector}__content-wrapper u-display__flex u-flex_alignitems--center u-flex__justifycontent--space-between">
                            <div class="${this.styleSelector}__content" data-content>
                                <h1 class="c-heading-stripe__heading" data-heading></h1>
                                <div data-child-root></div>
                            </div>
                            <span class="${this.styleSelector}__right u-display__none" data-slot="right" data-right></span>
                        </div>
                        <div>
                            <span data-slot="tabs" data-tabs></span>
                        </div>
                    </w-wrapper>
                </w-section>`;

    static get observedProps() {
        return [
            new wealthify.Prop('heading', { required: true }),
            new wealthify.Prop('variant', { default: 'gradient-1' }),
            new wealthify.Prop('back-button-details', {
                type: wealthify.propTypes.Object(),
                validator: wealthify.propValidators.ObjectContainsKeys(this.#backButtonRequiredProperties)
            }),
            new wealthify.Prop('remove-bottom-padding', {
                type: wealthify.propTypes.Boolean(),
                default: false
            }),
            new wealthify.Prop('is-content-header', {
                type: wealthify.propTypes.Boolean(),
                default: false
            })
        ];
    }

    // public

    get propCallbacks() {
        return {
            heading: (value) => this.dom.heading.innerHTML = value,
            variant: (value) => this.dom.root.variant = value,
            backButtonDetails: () => {
                if (this.backButtonDetails) {
                    const backButton = this.dom.content.querySelector('.u-text__back-link') || document.createElement('a');

                    backButton.classList.add('u-text__back-link', 'u-margin__bottom-mobile--spacing-xl');
                    backButton.href = this.backButtonDetails.link;
                    backButton.textContent = this.backButtonDetails.label;

                    this.dom.content.insertBefore(backButton, this.dom.heading);
                }
            },
            removeBottomPadding: () => {
                if (this.removeBottomPadding) {
                    this.dom.wrapper.classList.add('u-padding__bottom-mobile--0');
                }
            },
            isContentHeader: () => {
                const classListAction = this.isContentHeader ? 'add' : 'remove';

                this.dom.wrapper.classList[classListAction]('u-text__align--left');
            }
        };
    }

    // private

    static #backButtonRequiredProperties() {
        return [
            'label',
            'link'
        ];
    }

    get #isValidTabSlot() {
        return this.dom.tabs?.tagName?.toLowerCase() === 'span' ||
            this.dom.tabs?.tagName?.toLowerCase() === 'w-tab-panel-menu';
    }

    get #isRightSlotted() {
        return this.dom.right?.tagName?.toLowerCase() !== 'span';
    }
});